"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: intercom/intercom-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fintercom%2Fintercom-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntercomServiceClient = exports.AuthenticateResponse = exports.AuthenticateRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const intercom_key_type_1 = require("./intercom-key-type");
const protobufPackage = 'com.step.intercom.proto';
function createBaseAuthenticateRequest() {
    return { env: '', keyType: intercom_key_type_1.IntercomKeyType.INVALID };
}
exports.AuthenticateRequest = {
    fromJSON(object) {
        const message = {
            env: isSet(object.env) ? globalThis.String(object.env) : '',
            keyType: isSet(object.keyType)
                ? (0, intercom_key_type_1.intercomKeyTypeFromJSON)(object.keyType)
                : intercom_key_type_1.IntercomKeyType.INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.env !== '') {
            obj.env = message.env;
        }
        if (message.keyType !== intercom_key_type_1.IntercomKeyType.INVALID) {
            obj.keyType = (0, intercom_key_type_1.intercomKeyTypeToJSON)(message.keyType);
        }
        return obj;
    },
    create(base) {
        return exports.AuthenticateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAuthenticateRequest();
        message.env = object.env ?? '';
        message.keyType = object.keyType ?? intercom_key_type_1.IntercomKeyType.INVALID;
        return message;
    },
};
function createBaseAuthenticateResponse() {
    return { userHash: '' };
}
exports.AuthenticateResponse = {
    fromJSON(object) {
        const message = {
            userHash: isSet(object.userHash) ? globalThis.String(object.userHash) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userHash !== '') {
            obj.userHash = message.userHash;
        }
        return obj;
    },
    create(base) {
        return exports.AuthenticateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAuthenticateResponse();
        message.userHash = object.userHash ?? '';
        return message;
    },
};
/**
 * Intercom Service. Currently only used to authenticate customers.
 */
class IntercomServiceClient {
    rpc;
    name = 'com.step.intercom.proto.IntercomService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/intercom';
    methods = [{
            name: 'Authenticate',
            requestType: exports.AuthenticateRequest,
            responseType: exports.AuthenticateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Authenticate a customer.
     */
    authenticate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.IntercomServiceClient = IntercomServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=intercom-service.js.map